export const faqs = [
  {
    q: 'How will I receive the materials?',
    a: 'Immediately after your purchase, you’ll receive instructions to access the digital materials. The six volumes and five bonuses are provided in downloadable digital formats.',
  },
  {
    q: 'Is this a course?',
    a: 'No. The Sensory Modulation Clinical Pathway™ is a practical educational toolkit containing visual frameworks, worksheets, matrices, checklists, and fictional case exercises. You can work through the materials at your own pace and return to individual resources whenever you need them.',
  },
  {
    q: 'Who is this product for?',
    a: 'It’s designed for Pediatric Occupational Therapists and occupational therapy students who want a more structured way to organize observations and explore sensory modulation questions. The materials are educational resources and are not a substitute for supervised clinical training or professional judgment.',
  },
  {
    q: 'Do I need previous experience with sensory integration?',
    a: 'A basic familiarity with pediatric occupational therapy and sensory processing terminology will help you get the most out of the materials. The glossary and explanations are designed to help you review key concepts as you work through the pathway.',
  },
  {
    q: 'Does this product diagnose sensory modulation difficulties?',
    a: 'No. The Sensory Modulation Clinical Pathway™ is an educational reasoning and organization resource. It does not diagnose children, establish clinical classifications, replace standardized assessments, or determine individualized treatment decisions.',
  },
  {
    q: 'Does it replace standardized assessments or professional training?',
    a: 'No. It is intended to complement professional learning and structured case organization, not replace standardized assessment procedures, certification requirements, multidisciplinary evaluation, or professional clinical judgment.',
  },
  {
    q: 'Can I print the materials?',
    a: 'Yes. The printable worksheets and checklists are designed to be used digitally or printed for personal professional reference, subject to the product’s applicable usage terms.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. The advertised price is a one-time payment of USD $27. There is no monthly subscription.',
  },
  {
    q: 'How long will I have access?',
    a: 'You’ll receive lifetime access to the purchased digital materials, subject to the applicable product terms.',
  },
  {
    q: 'What if I change my mind?',
    a: 'Your purchase includes a 7-day guarantee, subject to the applicable purchase terms. If you decide the product isn’t right for you within that period, you can request a refund according to those terms.',
  },
];
